import PropTypes from 'prop-types'
import { LiveEventPageQuery } from '@layouts/live-event'

import withNoCachePage from '@lib/withNoCachePage'

const LiveEventPage = ({ query }) => {
  return (
    <LiveEventPageQuery {...query} />
  )
}

LiveEventPage.getInitialProps = async ({ query }) => ({ query })

LiveEventPage.propTypes = {
  query: PropTypes.object,
}

export default withNoCachePage(LiveEventPage)
